import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_API_SECRET.trim();

// Parse Base64 key into WordArray
const key = CryptoJS.enc.Base64.parse(SECRET_KEY);

// URL-safe Base64 encoding
const toUrlSafeBase64 = (wordArray) => {
  return CryptoJS.enc.Base64.stringify(wordArray)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, ""); // remove padding
};

export const encryptValue = (value) => {
  if (!value) return "";
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(value.toString(), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const ivAndCiphertext = iv.concat(encrypted.ciphertext);
  return toUrlSafeBase64(ivAndCiphertext);
};


// Encrypt all values in an object
export const encryptObject = (obj) => {
  if (!obj) return {};
  const encryptedObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      encryptedObj[key] = encryptValue(obj[key]);
    }
  }
  return encryptedObj;
};
